import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CompanySector } from '../models/empresa.model';

@Injectable({
  providedIn: 'root'
})
export class CompanySectorApiService {
  private readonly apiUrl = `${environment.apiUrl}api/company-sectors`;

  constructor(private http: HttpClient) { }

  // GET /api/company-sectors - List all sectors (global + tenant-specific)
  getAll(): Observable<CompanySector[]> {
    return this.http.get<CompanySector[]>(this.apiUrl);
  }

  // GET /api/company-sectors/global - List only global sectors
  getGlobal(): Observable<CompanySector[]> {
    return this.http.get<CompanySector[]>(`${this.apiUrl}/global`);
  }

  // GET /api/company-sectors/business/{businessId} - List sectors for specific tenant
  getByBusiness(businessId: number): Observable<CompanySector[]> {
    return this.http.get<CompanySector[]>(`${this.apiUrl}/business/${businessId}`);
  }

  // GET /api/company-sectors/{id} - Get by ID
  getById(id: number): Observable<CompanySector> {
    return this.http.get<CompanySector>(`${this.apiUrl}/${id}`);
  }

  // POST /api/company-sectors - Create (requires Sales Rep or higher)
  create(companySector: Omit<CompanySector, 'id'>): Observable<CompanySector> {
    return this.http.post<CompanySector>(this.apiUrl, companySector);
  }

  // PUT /api/company-sectors/{id} - Update (requires Sales Rep or higher)
  update(id: number, companySector: Omit<CompanySector, 'id'>): Observable<CompanySector> {
    return this.http.put<CompanySector>(`${this.apiUrl}/${id}`, companySector);
  }

  // DELETE /api/company-sectors/{id} - Delete (requires Admin or higher)
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
